import React from 'react';
import { useAuthentication } from '../../../../../apps/bfi-apply/src/app/LoginPage';
import '../../scss/controls/_signature.scss';

interface SignatureProps {
    firstName?: string;
    lastName?: string;
}

export const Signature: React.FC<SignatureProps> = ({ firstName, lastName }) => {
    const { authentication } = useAuthentication();
    const userFirstName = authentication ? authentication?.user.firstName : firstName;
    const userLastName = authentication ? authentication?.user.lastName : lastName;

    return (
        <div className='signature'>
            <span className='typedText'>Signed by:</span>
            <span className='sign'>
                {userFirstName} {userLastName}
            </span>
            <span className='typedText'>
                {userFirstName} {userLastName}
            </span>
        </div>
    );
};
